import * as React from 'react';


import { useNavigate } from 'react-router-dom';


import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import Backdrop from '@mui/material/Backdrop';

import CircularProgress from '@mui/material/CircularProgress';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import PersonIcon from '@mui/icons-material/Person';

import { styled } from '@mui/material/styles';

import Top from "../Top";
import Bottom from "../Bottom";
import { Grid } from '@mui/material';

import tab04 from "../../assets/images/tab_01.png"


const UsePolicy = () => {

  const navigate = useNavigate();




  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  const img = {
    display: 'flex', p: 0, backgroundImage: `url(${tab04})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
  }

  return (
    <Container className="container">
      <Box sx={img} className='topImg'>
        <Grid container spacing={2} direction='row' justifyContent='center' alignItems={'center'} sx={{ overflow: 'hidden', height: 200, textAlign: 'center' }}>
          <Grid item container xs sx={{ pl: 0 }} direction='column' justifyContent='center'>
            <Typography className='topText' sx={{ fontSize: '2.2rem', color: '#8acd83', fontWeight: 900 }}>
              이용안내
            </Typography>
            <Typography sx={{ fontSize: '1.8rem', color: '#5ead3d', fontWeight: 500, }} gutterBottom>
              검진이용 및 취소/환불 규정
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Box className={'contentStart'}
        sx={{
          p: '0 15px 80px 15px',
          mt: 10,
          '& > p': {
            fontSize: 12, fontWeight: 'normal'
          },
          'p.fontred': { fontSize: 12, fontWeight: '700', color: '#ef0000' },
          'ol': { paddingLeft: '20px' },
          'ul': { paddingLeft: '20px' },
          'li': { fontSize: 12 },
          'h2': { textAlign: 'center', fontSize: 24 },
          'h3': { fontSize: 14 },
          'p span': { fontSize: 12, color: '#0045e3', fontWeight: 700 },

        }}>

        <h2>듀얼헬스케어 검진이용 및 취소/환불 규정</h2>
        <p>&nbsp;</p>


        <h3>이용규정</h3>
        <p>검진센터는 대부분 현장 접수가 아닌 사전 예약제로 운영하고 있으며, 검진 센터 내에서 실시간으로 예약이 이루어지기 때문에 ㈜듀얼헬스케어 서비스에서 희망하는 일자를 입력하더라도 건강검진 확정일은 달라질 수 있습니다.</p>
        <p>건강검진 희망일은 신청일로부터 14일 이후에 선택할 수 있으며, 만약 희망하는 일자에 건강검진이 어려운 경우 병원에서 직접 안내 전화를 드려 일정을 조율합니다.</p>
        <p>건강검진 일자를 확정하기 위해 병원에서 안내 전화를 드리지만 2일 이상 고객님과 연락이 되지 않는 경우 예약이 취소될 수 있는 점 유의 바랍니다. </p>
        <p>㈜듀얼헬스케어에서는 이용자가 선택한 병원에 건강검진을 예약하는 지원 업무를 해드리고 있습니다. 병원의 사정으로 인해 발생되는 문제나, 병원에 방문하여 문제가 생기는 경우 모든 책임은 병원에 있습니다.</p>
        <p>&nbsp;</p>

        <h3>이용 대상</h3>
        <p>본 서비스는 ㈜듀얼헬스케어에 가입한 회원에 한해 건강검진을 예약할 수 있으며, 회원 본인이 아니더라도 추가 절차에 따라 가족이나 지인의 건강검진을 대리 예약하거나 결제할 수 있습니다.</p>
        <p>미성년자와 70세 이상의 이용자도 건강검진을 예약할 수 있지만, 병원 사정에 따라 건강검진 항목의 제한 또는 건강검진이 불가능할 수 있습니다.</p>
        <p>&nbsp;</p>

        <h3>검진결과 조회</h3>
        <p>검진결과 모바일 조회 서비스는 ㈜듀얼헬스케어 회원 본인이 건강검진을 받는 경우 검진 결과를 조회할 수 있습니다.</p>
        <p>가족이나 지인의 건강검진을 대리 예약하는 경우 검진결과는 조회할 수 없습니다.</p>
        <p>건강검진 완료 후 개인정보제공 동의를 하신 회원에 한하여 검진 결과를 병원으로부터 제공받아 등록되며 검진결과가 등록되기까지 건강검진 수검일로부터 최소 45일에서 최대 90일이 소요될 수 있습니다.</p>
        <p>㈜듀얼헬스케어는 검진 결과에 대해 주관적인 판단이나 의견을 제시하지 않으며, 단순히 결과값만을 제공합니다. 그러나 병원마다 참고하는 정상 범위 또는 표기하는 단위가 조금씩 다를 수 있으므로 이 점 유의하시기 바랍니다. </p>
        <p>&nbsp;</p>

        <h3>서비스 불만족</h3>
        <p>병원에서 건강검진을 받거나 기타 서비스로 인해 불편함을 겪으신 경우 이로 인한 배상은 병원에 직접 요청하셔야 합니다. ㈜듀얼헬스케어는 고객이 병원에 건강검진을 신청하는데 있어 고객 지원을 해드리고 있기 때문에 병원에 제3자로서 고객님의 불편사항을 대신 전달할 수 없음을 양해 부탁드립니다.</p>
        <p>&nbsp;</p>

        <h3>취소/환불 규정</h3>
        <p className='fontred'>㈜듀얼헬스케어에서는 이용자와 병원 간의 원활한 업무, No-Show(노쇼) 방지를 위해 플랫폼 서비스를 제공하며 의료기관에 납부하는 건강검진비(의료비용)를 제외한 일정 금액을 예약 보증금 형태의 수수료로 받습니다. 검진센터의 특성상 노쇼 발생시 검진센터의 손실이 발생하게 되며 또한 건강검진 항목에 따라 1~2주 전에 전처치약(예. 내시경 약)과 문진이 미리 발송이 됩니다. 따라서 일정 부분의 예약 보증금이 불가피한 점 유의바랍니다.</p>
        <p>건강검진 일자가 <span>“예약대기”</span> 상태라면 언제든 건강검진을 취소하거나 날짜를 변경할 수 있습니다. 건강검진 취소 수수료는 발생하지 않습니다. </p>
        <p>건강검진 일자가 <span>“확정일”</span> 상태로 변경되었다면, 확정일로부터 7일 전까지 100% 환불이 가능합니다. </p>
        <p>건강검진 <span>"확정일"</span> 7일 전부터 당일 및 노쇼인 경우 환불이 불가합니다.</p>
        <p>병원 정보나 검진상품 정보가 실제와 다른 경우, “예약확정” 상태이더라도 언제든 건강검진을 취소할 수 있습니다. </p>
        <p>병원 사정으로 일부 검사가 변경되는 경우, 건강검진을 취소하거나 해당 검사항목에 대한 비용을 부분 환불 받을 수 있습니다.</p>
        <p>성수기의 경우 일부 검사의 예약이 마감되어 다른 검사항목으로 대체되는 경우, 예약 확정 전에 병원에서 이용자에게 직접 미리 연락을 드립니다.</p>
        <p>건강검진을 취소하여 환불을 받는 경우 영업일 기준 약 3~4일 소요될 수 있습니다.</p>
        <p>&nbsp;</p>

        <h3>의료법 준수</h3>
        <p>의료법 상 영리를 목적으로 특정 병원을 중개하거나 알선하는 행위가 금지되어 있어 특정 병원을 고객에게 소개하지 않으므로 직접 병원을 검색하거나 선택하여 병원에 건강검진을 예약하게 됩니다.</p>
        <p>㈜듀얼헬스케어는 병원과 고객을 중개하는 행위를 하지 않으며 병원으로부터 중개수수료, 소개료, 알선료 등 어떠한 대가나 금품 등을 받지 않습니다. </p>
        <p>본인 부담금을 할인하거나 면제하는 행위는 의료법을 위반하는 행위입니다. ㈜듀얼헬스케어는 건강보험이 적용되지 않는 비급여 항목에 대해 할인 혜택을 제공하고 있습니다.</p>
        <p>또한 건강검진을 무료로 받을 수 있는 상품권이나 쿠폰을 발급하거나 유통하는 행위를 하지 않으며, 건강검진을 받는다고 해서 사은품을 지급하거나 특정 검사를 끼워 파는 행위는 하지 않습니다. </p>
        <p>&nbsp;</p>



      </Box>



      <Bottom />

    </Container>

  );
}


export default UsePolicy;